const EAN13_PATTERN = /^\d{13}$/;

export function isValidEan13(value: string) {
  if (!EAN13_PATTERN.test(value)) return false;
  const digits = value.split("").map(Number);
  const sum = digits.slice(0, 12).reduce(
    (total, digit, index) => total + digit * (index % 2 === 0 ? 1 : 3),
    0,
  );
  return (10 - (sum % 10)) % 10 === digits[12];
}
